<template>
  <div class="k2-sh-body">
    <section class="k2-sec">
      <h4>{{ tx("set.font") }}</h4>
      <div class="k2-segb" role="group">
        <button
          v-for="(f, i) in fonts"
          :key="f.v"
          type="button"
          :data-fk="'font-' + i"
          :aria-pressed="settings.font === f.v ? 'true' : 'false'"
          @click="$emit('set', 'font', f.v)"
        >
          <span :style="{ fontSize: 15 + i * 4 + 'px', fontWeight: 800 }">A</span>
          <small>{{ $t(f.label) }}</small>
        </button>
      </div>
    </section>

    <section class="k2-sec">
      <h4>{{ tx("set.sound_h") }}</h4>
      <div class="k2-row">
        <div class="k2-rl">
          <b>{{ tx("set.sound") }}</b>
          <span>{{ tx("set.sound_s") }}</span>
        </div>
        <button type="button" class="k2-sw" role="switch" :aria-checked="settings.sound ? 'true' : 'false'" :aria-label="tx('set.sound')" data-fk="sw-snd" @click="$emit('set', 'sound', !settings.sound)"></button>
      </div>
      <div class="k2-row">
        <div class="k2-rl">
          <b>{{ tx("set.remind") }}</b>
          <span>{{ tx("set.remind_s") }}</span>
        </div>
        <button type="button" class="k2-sw" role="switch" :aria-checked="settings.remind ? 'true' : 'false'" :aria-label="tx('set.remind')" data-fk="sw-remind" @click="$emit('set', 'remind', !settings.remind)"></button>
      </div>
      <div class="k2-row">
        <div class="k2-rl">
          <b>{{ tx("set.wake") }}</b>
          <span>{{ wakeSupported ? tx("set.wake_s") : tx("set.wake_no") }}</span>
        </div>
        <button
          type="button"
          class="k2-sw"
          role="switch"
          :aria-checked="settings.wake ? 'true' : 'false'"
          :aria-label="tx('set.wake')"
          :disabled="!wakeSupported"
          data-fk="sw-wake"
          @click="$emit('set', 'wake', !settings.wake)"
        ></button>
      </div>
    </section>

    <section class="k2-sec">
      <h4>{{ tx("set.accept_h") }}</h4>
      <div class="k2-row">
        <div class="k2-rl">
          <b>{{ tx("set.quick") }}</b>
          <span>{{ tx("set.quick_s", { est: dur(settings.lastEst) }) }}</span>
        </div>
        <button type="button" class="k2-sw" role="switch" :aria-checked="settings.quick ? 'true' : 'false'" :aria-label="tx('set.quick')" data-fk="sw-quick" @click="$emit('set', 'quick', !settings.quick)"></button>
      </div>
    </section>

    <section class="k2-sec">
      <h4>{{ tx("set.paging_h") }}</h4>
      <div class="k2-segb k2-segb--2" role="group">
        <button
          v-for="p in pagings"
          :key="p.v"
          type="button"
          :data-fk="'pg-' + p.v"
          :aria-pressed="settings.paging === p.v ? 'true' : 'false'"
          @click="$emit('set', 'paging', p.v)"
        >
          <span>{{ tx("set.paging_" + p.v) }}</span>
        </button>
      </div>
      <div class="k2-hint">{{ tx("set.paging_hint") }}</div>
    </section>

    <section class="k2-sec">
      <h4>{{ $t("kds_visible_columns") }}</h4>
      <div v-for="s in stages" :key="s.key" class="k2-row">
        <div class="k2-rl k2-rl--ic" :data-c="s.tone">
          <span class="k2-ci"><k2-icon :n="s.icon" :s="18" /></span>
          <b>{{ $t(s.labelKey) }}</b>
        </div>
        <button type="button" class="k2-sw" role="switch" :aria-checked="settings.vis[s.key] ? 'true' : 'false'" :aria-label="$t(s.labelKey)" :data-fk="'vis-' + s.key" @click="$emit('vis', s.key)"></button>
      </div>
    </section>

    <section v-if="wc !== 'xl'" class="k2-sec">
      <h4>{{ tx("set.view_h") }}</h4>
      <div class="k2-btnrow">
        <button type="button" class="k2-btn" data-fk="date2" @click="$emit('date', $event.currentTarget)">
          <k2-icon n="mdi-history" :s="20" /><span>{{ live ? $t("last_24h") : tx("set.older") }}</span>
        </button>
        <button v-if="fullscreenSupported" type="button" class="k2-btn" data-fk="fs2" @click="$emit('fullscreen')">
          <k2-icon n="mdi-fullscreen" :s="20" /><span>{{ tx("fullscreen.enter") }}</span>
        </button>
      </div>
    </section>

    <footer class="k2-sh-f">
      <button type="button" class="k2-btn" data-fk="rs" @click="$emit('reset')">{{ tx("set.reset") }}</button>
    </footer>
  </div>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import kds2Text from "@/mixins/kds2Text";
import { STAGES } from "@/utils/kdsTickets";

// Podešavanja prikaza: veličina teksta, zvuk, prihvatanje jednim dodirom, listanje, vidljive kolone.
export default {
  name: "Kds2Settings",
  components: { K2Icon },
  mixins: [kds2Text],
  props: {
    settings: { type: Object, required: true },
    wc: { type: String, required: true },
    live: { type: Boolean, default: true },
    wakeSupported: { type: Boolean, default: false },
    fullscreenSupported: { type: Boolean, default: false },
  },
  computed: {
    stages() {
      return STAGES;
    },
    fonts() {
      return [
        { v: 1, label: "kds_font_size_normal" },
        { v: 1.15, label: "kds_font_size_large" },
        { v: 1.3, label: "kds_font_size_xlarge" },
      ];
    },
    pagings() {
      return [{ v: "scroll" }, { v: "auto" }];
    },
  },
};
</script>
